import { useState } from 'react';
import WarehouseReceivingAddressService from './WarehouseReceivingAddressService';

function useManageWarehouseReceivingAddresses() {
  const [addresses, setAddresses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refreshAll = async () => {
    setIsLoading(true);
    try {
      const response = await WarehouseReceivingAddressService.getAll();
      setAddresses(response.data || []);
      setError(null);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const create = async (payload) => {
    setIsLoading(true);
    try {
      await WarehouseReceivingAddressService.create(payload);
      await refreshAll();
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const update = async (id, payload) => {
    setIsLoading(true);
    try {
      await WarehouseReceivingAddressService.update(id, payload);
      await refreshAll();
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const remove = async (id) => {
    setIsLoading(true);
    try {
      await WarehouseReceivingAddressService.remove(id);
      await refreshAll();
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const assignCustomer = async (warehouseReceivingAddressId, customerId) => {
    setIsLoading(true);
    try {
      await WarehouseReceivingAddressService.assignCustomer(warehouseReceivingAddressId, customerId);
      await refreshAll();
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const unassignCustomer = async (warehouseReceivingAddressId, customerId) => {
    setIsLoading(true);
    try {
      await WarehouseReceivingAddressService.unassignCustomer(warehouseReceivingAddressId, customerId);
      await refreshAll();
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { addresses, isLoading, error, refreshAll, create, update, remove, assignCustomer, unassignCustomer };
}

export default useManageWarehouseReceivingAddresses;
